import 'isomorphic-fetch'

import { getApiBaseUrlWithOrg } from '../utils'
import { basicGet } from '../utils/api'

export const FETCH_MOCK_COURSES_REQUEST = 'FETCH_MOCK_COURSES_REQUEST'
export const FETCH_MOCK_COURSES_SUCCESS = 'FETCH_MOCK_COURSES_SUCCESS'

export function fetchMockCoursesRequest() {
  return {
    type: FETCH_MOCK_COURSES_REQUEST
  }
}

export function fetchMockCoursesSuccess(response) {
  return {
    type: FETCH_MOCK_COURSES_SUCCESS,
    payload: {
      courses: response
    }
  }
}

export function fetchMockCourses() {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(state.organization.orgId)}/mock_courses`
    return basicGet(
      state,
      dispatch,
      url,
      fetchMockCoursesRequest,
      fetchMockCoursesSuccess
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/mockcourses.js